<template>
  <div class="tournament-content-tab tab-info" v-bind:class="{'tournament-content-active-tab':activeTab == 1}">
    <template v-if="item">
      <!-- Друк -->
      <section class="print-bar">
        <span class="print-title"><tkd-icon name="print"/> Друк</span>
        <a v-for="doc in printDocs" :key="doc.label" class="print-btn" :href="doc.href" target="_blank" rel="noopener">
          <span class="print-icon"><tkd-icon :name="doc.icon"/></span>{{ doc.label }}
        </a>
      </section>

      <!-- Статистика -->
      <section class="stats">
        <div class="stat" v-for="stat in stats" :key="stat.label" :class="stat.accent">
          <span class="stat-icon"><tkd-icon :name="stat.icon"/></span>
          <b>{{ stat.value }}</b>
          <span class="stat-label">{{ stat.label }}</span>
        </div>
      </section>

      <div class="sex-split" v-if="countRegionsMenWoman.men + countRegionsMenWoman.woman > 0">
        <div class="sex-bar">
          <span class="sex-men" :style="{ width: menPercent + '%' }"></span>
          <span class="sex-women" :style="{ width: (100 - menPercent) + '%' }"></span>
        </div>
        <div class="sex-legend">
          <span><i class="dot dot-men"></i>Хлопці {{ countRegionsMenWoman.men }} · {{ menPercent }}%</span>
          <span><i class="dot dot-women"></i>Дівчата {{ countRegionsMenWoman.woman }} · {{ 100 - menPercent }}%</span>
        </div>
      </div>

      <!-- Списки -->
      <div class="lists">
        <section class="panel" v-for="block in blocks" :key="block.title">
          <div class="panel-head">
            <h3>{{ block.title }}</h3>
            <span class="panel-count">{{ block.rows.length }}</span>
          </div>
          <div class="panel-sub">{{ block.subtitle }}</div>
          <ul class="rank-list" v-if="block.rows.length">
            <li v-for="(row, i) in block.rows" :key="i">
              <div class="rank-row">
                <span class="rank-name">
                  {{ row.name || 'не вказано' }}
                  <small v-if="row.sub">{{ row.sub }}</small>
                </span>
                <b class="rank-value">{{ row.count }}</b>
              </div>
              <div class="rank-bar"><span :style="{ width: barWidth(row.count, block.max) }"></span></div>
            </li>
          </ul>
          <div class="panel-empty" v-else>Даних ще немає</div>
        </section>
      </div>

      <!-- Опис -->
      <section class="panel description" v-if="item.description">
        <div class="panel-head"><h3>Опис турніру</h3></div>
        <div class="description-body" v-html="item.description"></div>
        <!--                TODO Додати перевiрку на JS при створенні-редагуванні-->
      </section>
    </template>
  </div>
</template>

<script>

import 'src/assets/css/tkd-theme.css';
import {baseUrlServer} from "../../api/user";

export default {
  name: "tab-info",
  created(){
    this.baseUrlServer = baseUrlServer;
  },
  data() {
    return {
      regions: [],
    }
  },
  computed: {
    activeTab() {
      return this.$store.getters['settings/activeTournamentTab'];
    },
    tournamentOne() {
      return this.$store.getters['tournament/tournamentOne'];
    },
    item() {
      return this.tournamentOne && this.tournamentOne.data ? this.tournamentOne.data.item : null;
    },
    printDocs() {
      let href = this.baseUrlServer + '/tournament-report/print-pdf?id=' + this.item.id;
      return [
        { icon: 'trophy', label: 'Результати', href },
        { icon: 'bracket', label: 'Жеребкування (всі протоколи)', href },
        { icon: 'scale', label: 'Протоколи зважування', href },
      ];
    },
    stats() {
      return [
        { icon: 'dobok', label: 'Спортсменів', value: this.countSportsmans, accent: 'accent-blue' },
        { icon: 'club', label: 'Клубів / організацій', value: this.countOrganizations },
        { icon: 'belt', label: 'Категорій', value: this.countCategories },
        { icon: 'map', label: 'Областей', value: this.countRegionsMenWoman.regions },
        { icon: 'athlete-boy', label: 'Хлопців', value: this.countRegionsMenWoman.men },
        { icon: 'athlete-girl', label: 'Дівчат', value: this.countRegionsMenWoman.woman },
      ];
    },
    menPercent() {
      let total = this.countRegionsMenWoman.men + this.countRegionsMenWoman.woman;
      return total ? Math.round(this.countRegionsMenWoman.men / total * 100) : 0;
    },
    blocks() {
      let regions = this.regionsList.map(region => ({ name: region.name, count: region.count }));
      let organizations = (this.item.organizations || [])
        .map(org => ({ name: org.organization, sub: org.oblast, count: Number(org.registered) || 0 }))
        .sort((a, b) => b.count - a.count);
      let categories = this.tournamentProtocols
        .filter(protocol => protocol.count_sportsmans > 0)
        .map(protocol => ({ name: protocol.fullname, count: Number(protocol.count_sportsmans) }));
      let withMax = (title, subtitle, rows) => ({
        title, subtitle, rows, max: rows.reduce((max, row) => Math.max(max, row.count), 0)
      });
      return [
        withMax('Області', 'Учасників з області', regions),
        withMax('Організації', 'Зареєстровано учасників', organizations),
        withMax('Категорії', 'Учасників у категорії', categories),
      ];
    },

    countSportsmans() {
      if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.sportsmans) {
        return 0;
      }
      return  this.tournamentOne.data.item.sportsmans.length
    },

    countOrganizations() {
      if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.organizations) {
        return 0;
      }
      return  this.tournamentOne.data.item.organizations.length
    },
    regionsList() {
      let regions = {};

      // Check if sportsmans data exists
      if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.sportsmans) {
        return [];
      }

      for (const sportsman of this.tournamentOne.data.item.sportsmans){

        if(regions[sportsman.oblast] != undefined){
          regions[sportsman.oblast]['count']++;
        }else{
          regions[sportsman.oblast] = {
            name: sportsman.oblast,
            count:  1
          }
        }
      }


      let regionsArr = [];
      let keys = Object.keys(regions);

      for (let i  in keys) {
        regionsArr.push(regions[keys[i]])
      }


      return  regionsArr.sort(function (a, b){
        if ( a.count > b.count ){
          return -1;
        }
        if ( a.count < b.count ){
          return 1;
        }
        return 0;
      });
    },

    countRegionsMenWoman() {
      let counts = {regions:0, men:0, woman:0};
      let regions = [];
      let men = [];
      let woman = [];

      // Check if sportsmans data exists
      if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.sportsmans) {
        return counts;
      }

      for (const sportsman of this.tournamentOne.data.item.sportsmans){
        if(regions.includes(sportsman.oblast) !== true) regions.push(sportsman.oblast)
        if(sportsman.sex === "1") men.push(sportsman.oblast)
        if(sportsman.sex === "2") woman.push(sportsman.oblast)
      }

      counts.regions = regions.length;
      counts.men = men.length;
      counts.woman = woman.length;

      return  counts;
    },
    tournamentProtocols() {
      if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.protocols) {
        return [];
      }
      return this.tournamentOne.data.item.protocols.slice().sort((a, b) => b.count_sportsmans - a.count_sportsmans);
    },

    countCategories() {
      if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.protocols) {
        return 0;
      }
      return  this.tournamentOne.data.item.protocols.filter(function (el){return el.count_sportsmans > 0}).length;
    },
  },
  methods: {
    barWidth(count, max) {
      return max ? Math.max(4, Math.round(count / max * 100)) + '%' : '0%';
    }
  }
}
</script>

<style scoped>
  .tab-info {
    background: transparent;
    font-family: var(--tkd-font);
    color: var(--tkd-text);
  }

  .panel {
    background: var(--tkd-surface);
    border: 1px solid var(--tkd-border);
    border-radius: var(--tkd-radius-lg);
    padding: 22px 22px 20px;
    box-shadow: var(--tkd-shadow);
  }

  /* Print */
  .print-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
  }

  .print-title { margin-right: 6px; font-size: 14px; font-weight: 700; color: var(--tkd-muted); }

  .print-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    padding: 0 14px;
    border-radius: var(--tkd-radius);
    border: 1.5px solid var(--tkd-border);
    background: var(--tkd-surface);
    font-size: 14px;
    font-weight: 600;
    color: var(--tkd-text);
    text-decoration: none;
    transition: border-color 0.15s, box-shadow 0.15s, color 0.15s;
  }

  .print-btn:hover { color: var(--tkd-blue); text-decoration: none; border-color: var(--tkd-blue); box-shadow: 0 0 0 4px rgba(0, 87, 183, 0.08); }
  .print-btn:focus-visible { outline: 2px solid var(--tkd-blue); outline-offset: 2px; }

  /* Stats */
  .stats {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 12px;
  }

  .stat {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 16px;
    border-radius: var(--tkd-radius-lg);
    background: var(--tkd-surface);
    border: 1px solid var(--tkd-border);
    box-shadow: var(--tkd-shadow);
  }

  .stat-icon { font-size: 20px; margin-bottom: 6px; }
  .stat b { font-size: 28px; font-weight: 800; line-height: 1.1; }
  .stat-label { font-size: 13px; color: var(--tkd-muted); }

  .stat.accent-blue { border-color: transparent; color: #fff; background: var(--tkd-gradient-btn); box-shadow: 0 10px 24px rgba(0, 87, 183, 0.3); }
  .stat.accent-blue .stat-label { color: rgba(255, 255, 255, 0.8); }

  .sex-split { margin-top: 14px; }

  .sex-bar {
    display: flex;
    height: 10px;
    border-radius: 999px;
    overflow: hidden;
    background: var(--tkd-border);
  }

  .sex-men { background: var(--tkd-blue); }
  .sex-women { background: var(--tkd-yellow); }

  .sex-legend {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-top: 8px;
    font-size: 13px;
    font-weight: 600;
    color: var(--tkd-text);
  }

  .dot { display: inline-block; width: 8px; height: 8px; margin-right: 6px; border-radius: 50%; }
  .dot-men { background: var(--tkd-blue); }
  .dot-women { background: var(--tkd-yellow); }

  /* Lists */
  .lists {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-top: 20px;
    align-items: start;
  }

  .panel-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .panel-head h3 { margin: 0; font-size: 18px; font-weight: 800; color: var(--tkd-text); }

  .panel-count {
    min-width: 28px;
    padding: 2px 9px;
    border-radius: 999px;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    color: var(--tkd-blue);
    background: rgba(0, 87, 183, 0.1);
  }

  .panel-sub { margin: 2px 0 14px; font-size: 13px; color: var(--tkd-muted); }

  .rank-list {
    max-height: 420px;
    margin: 0;
    padding: 0 6px 0 0;
    list-style: none;
    overflow-y: auto;
  }

  .rank-list li + li { margin-top: 12px; }

  .rank-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    font-size: 14px;
  }

  .rank-name { min-width: 0; overflow-wrap: anywhere; }
  .rank-name small { display: block; font-size: 12px; color: var(--tkd-muted); }
  .rank-value { flex-shrink: 0; font-size: 15px; }

  .rank-bar {
    height: 6px;
    margin-top: 6px;
    border-radius: 999px;
    background: var(--tkd-bg);
    overflow: hidden;
  }

  .rank-bar span {
    display: block;
    height: 100%;
    border-radius: 999px;
    background: var(--tkd-gradient-btn);
  }

  .panel-empty {
    padding: 20px 0;
    text-align: center;
    font-size: 14px;
    color: var(--tkd-muted);
  }

  .description { margin-top: 20px; }
  .description-body { margin-top: 12px; font-size: 15px; line-height: 1.6; overflow-wrap: anywhere; }
  .description-body >>> img { max-width: 100%; height: auto; }

  @media (max-width: 1199px) {
    .stats { grid-template-columns: repeat(3, 1fr); }
    .lists { grid-template-columns: repeat(2, 1fr); }
  }

  @media (max-width: 767px) {
    .stats { grid-template-columns: repeat(2, 1fr); gap: 10px; }
    .stat { padding: 14px; }
    .stat b { font-size: 24px; }
    .lists { grid-template-columns: 1fr; }
    .panel { padding: 18px 16px; }
    .print-title { width: 100%; }
    .print-btn { flex: 1 1 100%; }
  }
</style>
